import { render, staticRenderFns } from "./from0tohero.vue?vue&type=template&id=5dc29478&scoped=true"
import script from "./from0tohero.vue?vue&type=script&lang=js"
export * from "./from0tohero.vue?vue&type=script&lang=js"
import style0 from "./from0tohero.vue?vue&type=style&index=0&id=5dc29478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc29478",
  null
  
)

export default component.exports